import axios from "axios";

export const GET_USER = "GET_USER";
export const GET_USERS = "GET_USERS";
export const UPLOAD_PICTURE = "UPLOAD_PICTURE";
export const UPLDATE_PROFIL = "UPDATE_PROFIL";
export const DELETE_USER = "DELETE_USER";

export const getUser = (uid) => {
    return (dispatch) => {
        return axios
            .get(`${process.env.REACT_APP_API_URL}/api/user/${uid}`)
            .then((res) => {
                dispatch({
                    type: GET_USER,
                    payload: res.data
                })
            })
            .catch((err) => console.log(err))
    }
};

export const fetchCurrentUser = () => {
  return (dispatch) => {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/jwtid`, { withCredentials: true })
      .then((res) => {
        const uid = res.data;
        if (uid) {
          dispatch(getUser(uid));
        } else {
          console.log("Utilisateur non connecté");
        }
      })
      .catch((err) => console.log("Erreur lors de la récupération de l'uid:", err));
  };
};

export const getUsers = () => {
    return (dispatch) => {
      return axios
        .get(`${process.env.REACT_APP_API_URL}/api/user`)
        .then((res) => {
          dispatch({ type: GET_USERS, payload: res.data });
        })
        .catch((err) => console.log(err));
    };
};

export const uploadPicture = (data, id) => {
    return (dispatch) => {
        console.log("📤 Envoi de l'image..."); // Vérifie que cette ligne s'affiche
        return axios
            .post(`${process.env.REACT_APP_API_URL}api/user/uploadProfilePicture`, data)
            .then((res) => {
                console.log("✅ Image uploadée :", res.data); // Vérifie que l'upload a fonctionné

                return axios
                    .get(`${process.env.REACT_APP_API_URL}api/user/${id}`)
                    .then((res) => {
                        console.log("🔄 Données utilisateur après update :", res.data);
                        dispatch({ type: GET_USER, payload: res.data }); // Mise à jour complète du user
                    });
            })
            .catch((err) => console.log("Erreur upload :", err));
    };
};



export const updateProfil = (userId, updatedData) => {
    return (dispatch) => {
        return axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL}/api/user/` + userId,
            data: updatedData 
        })
        .then((res) => {
            dispatch({type: UPLDATE_PROFIL, payload:updatedData})
        })
        .catch((err) => console.log(err))
    }
}

export const deleteUser = (userId) => {
  return (dispatch) => {
    return axios
      .delete(`${process.env.REACT_APP_API_URL}/api/user/${userId}`)
      .then(() => {
        dispatch({ type: DELETE_USER, payload: userId });
      })
      .catch((err) => console.log("Erreur suppression utilisateur :", err));
  };
};